/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import ArtworkMultiDimensions from "./ArtworkMultiDimensions.vue";
import StepWrapper from "../common/StepWrapper.vue";
import PreCut from "../PreCut.vue";
import UploadBox from "../UploadBox.vue";

export default function MultiSizeStep({
  artwork = null,
  index = 0,
  disabled = false,
  readonly = false,
  withPreCut = false,
  showMultiUploadBox = false,
  showFileDialog = null,
  showFreeTransfersBadge = false,
  onShowFileDialog,
  ...restProps
}: any) {
  function handleShowFileDialog(data: any) {
    onShowFileDialog?.(data);
  }

  return (
    <StepWrapper
      {...restProps}
      stepNumber={2}
      headerText="Set Design Size"
      data-testid="step-wrapper"
    >
      {/* @ts-expect-error TS(2741): Property 'className' is missing in type '{ artwork... Remove this comment to see the full error message */}
      <ArtworkMultiDimensions
        artwork={artwork}
        index={index}
        disabled={disabled}
        readonly={readonly}
        showFreeTransfersBadge={showFreeTransfersBadge}
        data-testid="artwork-multi-dimensions"
      />
      {withPreCut ? <PreCut data-testid="pre-cut" /> : null}
      {showMultiUploadBox ? (
        <UploadBox onUpload={handleShowFileDialog} data-testid="upload-box" />
      ) : null}
    </StepWrapper>
  );
}
